import { Box, Grid, Link as MuiLink, Typography } from "@mui/material";
import { format, parseISO } from "date-fns";
import Image from "next/image";
import Link from "next/link";
import * as React from "react";
import Head from "./head";

export default function Home({ blogs }): React.ReactElement {
  return (
    <Box>
      <Head />

      <Box
        sx={{
          my: 4,
          mx: "auto",
          px: 2,
          maxWidth: (theme) => theme.breakpoints.values.lg,
        }}
      >
        <Typography variant="h4" component="h2">
          Recent Blogs
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={3}>
            {blogs.map((item) => (
              <Grid item xs={12} sm={6}>
                <Link href={`/blog/${item.slug}`} passHref>
                  <MuiLink color="inherit" underline="hover">
                    <Box>
                      <Box
                        sx={{
                          height: 240,
                          position: "relative",
                        }}
                      >
                        <Image
                          src={item.coverImage}
                          layout="fill"
                          objectFit="cover"
                          alt={item.title.toLocaleLowerCase()}
                          unoptimized={true}
                        />
                      </Box>
                      <Typography sx={{ mt: 1 }}>{item.title}</Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="div"
                        sx={{
                          mt: 0.5,
                          fontSize: (theme) =>
                            theme.typography.caption.fontSize,
                          textDecoration: "none",
                          "&:hover": {
                            textDecoration: "none",
                          },
                        }}
                      >
                        {format(parseISO(item.date), "MMMM do, yyyy")}
                      </Typography>
                    </Box>
                  </MuiLink>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
